import { ArtistCredit, artistCreditsFromJson } from '../artistList/artist';

export class Track {
    private id: number;
    private title: string;
    private artists: ArtistCredit[];
    private album: string;
    private duration: number;
    private albumId?: number;
    private trackNumber?: number;
    private discNumber?: number;
    private mbid?: string;

    constructor(
        id: number,
        title: string,
        artists: ArtistCredit[],
        album: string,
        duration: number,
        albumId?: number,
        trackNumber?: number,
        mbid?: string,
        discNumber?: number
    ) {
        this.id = id;
        this.title = title;
        this.artists = artists;
        this.album = album;
        this.duration = duration;
        this.albumId = albumId;
        this.trackNumber = trackNumber;
        this.mbid = mbid;
        this.discNumber = discNumber;
    }

    public getId(): number {
        return this.id;
    }

    public getTitle(): string {
        return this.title;
    }

    /** Every artist credited on this specific track (features/collaborations included). */
    public getArtists(): ArtistCredit[] {
        return this.artists;
    }

    /** The first credited artist's name, for places that need a single display string. */
    public getArtist(): string {
        return this.artists[0]?.title ?? '';
    }

    /** The first credited artist's id, for places that need a single link target. */
    public getArtistId(): number | undefined {
        return this.artists[0]?.id;
    }

    public getAlbum(): string {
        return this.album;
    }

    public toString(): string {
        return `${this.getArtist()} - ${this.title} [${this.album}]`;
    }

    public getDuration(): number {
        return this.duration;
    }

    public getAlbumId(): number | undefined {
        return this.albumId;
    }

    public getTrackNumber(): number | undefined {
        return this.trackNumber;
    }

    public getDiscNumber(): number | undefined {
        return this.discNumber;
    }

    public getMbid(): string | undefined {
        return this.mbid;
    }

    public toJson(): object {
        return {
            id: this.id,
            title: this.title,
            artists: this.artists,
            album: this.album
        };
    }

    public static fromJson(json: any): Track {
        return new Track(
            json.id,
            json.title,
            artistCreditsFromJson(json.artists),
            json.album,
            json.duration,
            json.album_id,
            json.track_number,
            json.mbid,
            json.disc_number
        );
    }
}
